import React, { createRef, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Tree, Input, Col, Spin } from 'antd';
import { CloseCircleOutlined, CheckOutlined, UserOutlined } from '@ant-design/icons';
import { isEqual, cloneDeep } from 'lodash';
import { callApi } from 'utils';
import { SelectContext } from '../context';
const TreeNode = Tree.TreeNode;
const Search = Input.Search;
class SelectManager extends PureComponent {
	static contextType = SelectContext;
	constructor (props) {
		super(props);
		this.state = {
			expandedKeys: [],
			selectedKeys: props.selects.filter(val => val.flowUserSelectionType === 'manager').map(val => String(val.sourceIdA)),
			treeNodes: [],
			disabledObj: this.getDisabledObj(props.disabledSelects),
			scrollViewHeight: 0,
		};
		this.treeBox = createRef();
		this.searchBox = createRef();
	}

	componentDidMount () {
		let scrollViewHeight = 0;
		const {organizations} = this.props;
		if(this.treeBox.current && this.searchBox.current) {
			const searchBox = window.getComputedStyle(this.searchBox.current)
			scrollViewHeight = this.treeBox.current.parentElement.clientHeight - parseInt(searchBox.height) - parseInt(searchBox.marginTop) - parseInt(searchBox.marginBottom)
		}
		this.setState({
			scrollViewHeight,
		})
		if (organizations) {
			let id = String(organizations.id);
			this.setState({
				expandedKeys: [id],
			})
			this.initTree(organizations);
		}
	}

	componentWillReceiveProps (nextProps) {
		const {organizations} = this.props;
		const {selects} = nextProps;
		if (organizations !== nextProps.organizations && nextProps.organizations) {
			this.initTree(nextProps.organizations);
		}
		if (!isEqual(this.props.selects, selects)) {
			this.setState({
				selectedKeys: selects.filter(val => val.flowUserSelectionType === 'manager').map(val => String(val.sourceIdA))
			});
		}
	}
  //封装不可选择列表
  getDisabledObj = (disabledList = []) => {
  	let obj = {};
  	disabledList.filter(val => val.flowUserSelectionType === 'manager').forEach(val => {
  		obj[Number(val.sourceIdA)] ? '' : obj[Number(val.sourceIdA)] = true;
  	});
  	return obj;
  }
	/**
	 * 初始化所有部门
	 */
	initTree = (organizations) => {
		this.setState({
			treeNodes: this.generateNodes([organizations]),
		});
	}

	/**
	 * 生成部门组织树状数据结构
	 */
	generateNodes = (list) => {
		let {disabledObj} = this.state;
		const { isLazyLoadData } = this.props;
		return list.map(node => {
			const { children = [], name, id, selectedFlag, isLeaf } = node;
			if (children.length > 0 && !isLeaf) {
				return (
					<TreeNode
						disabled={disabledObj[id] || selectedFlag === 0 }
						allData={node}
						key={String(id)}
						isLeaf={ isLazyLoadData && !!isLeaf}
						title={
							<div>
								<UserOutlined className='type-icon'/>
								{name}
								<CheckOutlined className={'select-modal-checked-icon'}/>
							</div>
						}>
							{this.generateNodes(children)}
						</TreeNode>
				);
			}
			return (
				<TreeNode
					disabled={disabledObj[id] || selectedFlag === 0 }
					allData={node}
					key={String(id)}
					isLeaf={ isLazyLoadData && !!isLeaf}
					title={
						<div>
							<UserOutlined className='type-icon'/>
							{name}
							<CheckOutlined className={'select-modal-checked-icon'}/>
						</div>
					}/>
			);
		});
	}

	/**
	 * 选中树节点
	 */
	selectTreeNode = (keys, info) => {
		const {props} = this;
		let sNode = info.node;
		let param = {
			selectedKeys: keys
		};
		if (sNode) {
			let newSelect = {
				selectionName: sNode.allData.name + '负责人',
				flowUserSelectionType: 'manager',
				sourceIdA: sNode.key,
				sourceTypeA: 'source_department',
				sourceDataA: props.needAllData ? sNode.allData : undefined,
			};
			if (info.selected) {
				props.addItems([newSelect]);
			} else if (!info.selected) {
				props.removeItems([newSelect]);
			}
		}

		this.setState(param);
	}

	/**
	 * 点击展开/收缩树节点
	 */
	onExpand = (keys, info) => {
		this.setState({ expandedKeys: keys });
	}
	/**
	 * 生成搜索结果数据结构
	 */
	generateList = list => {
		let {disabledObj} = this.state;
		return list.map(node => {
			let { name, id, selectedFlag } = node;
			return <TreeNode disabled={disabledObj[id] || selectedFlag === 0 } allData={node} key={String(id)}
				title={<div><UserOutlined className='type-icon'/>{name}<CheckOutlined className={'select-modal-checked-icon'}/></div>}/>;
		});
	};
	/**
	 * 根据关键字搜索
	 */
	searchByKeywords = (keywords = '') => {
		const {organizations, privilegeFilterFlag } = this.props;
		const { manageSceneFlag } = this.context;
		keywords = keywords.trim();
		if (!keywords) return;
		this.setState({loading: true, showSearchBox: true});
		callApi({
			api: '/newOrg/findOrgPersonal',
			data: {
				organizationId: organizations.id,
				keywords,
				privilegeFilterFlag,
				appId: window.$$context.appId,
				manageSceneFlag
			},
			success: ({departments = []}) => {
				this.setState({
					searchList: this.generateList(departments),
					loading: false,
				});
			}
		});
	}
	render () {
		const {expandedKeys, selectedKeys, treeNodes, searchText, showSearchBox, searchList, loading, scrollViewHeight } = this.state;
		const { lazyLoadOrganization } = this.props;
		return (
			<Col className='tree-box' ref={this.treeBox}>
				<div className='select-box-search' ref={this.searchBox}>
					<Search
						placeholder="请输入部门"
						value={searchText}
						onChange={e => this.setState({ searchText: e.target.value })}
						onSearch={this.searchByKeywords}
					/>
        	<CloseCircleOutlined className={searchText ? 'search-close-circle' : 'display-none'}
						onClick={() => this.setState({searchText: '', showSearchBox: false})}/>
				</div>
				<div className={'select-scroll-view'}>
					{
						showSearchBox && searchText
							? loading
								? <Spin className='tree-box-center'/>
								: searchList.length < 1
									? <div className='tree-box-center'>未找到相关结果</div>
									: <Tree
										multiple
										height={scrollViewHeight}
										autoExpandParent={false}
										selectedKeys={selectedKeys}
										onSelect={this.selectTreeNode}
										onExpand={this.onExpand}
									>
										{searchList}
									</Tree>
							: <Tree
								multiple
								height={scrollViewHeight}
								autoExpandParent={false}
								expandedKeys={cloneDeep(expandedKeys)}
								selectedKeys={selectedKeys}
								onSelect={this.selectTreeNode}
								onExpand={this.onExpand}
								loadData={lazyLoadOrganization}
							>
								{treeNodes}
							</Tree>

					}
				</div>
			</Col>
		);
	}
}

SelectManager.propTypes = {
	organizations: PropTypes.object.isRequired, // 组织架构数据
	// 选中的列表， 数据结构为 [{selectionName: 显示名称, flowUserSelectionType: 'department', sourceIdA: ID, sourceTypeA: 'source_department'}]

	/* 以下是configs额外传进来的参数 */
	useDisable: PropTypes.bool,
	disabledSelects: PropTypes.array.isRequired,
	selects: PropTypes.array.isRequired,
	// 是否支持选择 '包含子部门'
	selectChild: PropTypes.bool,
	addItems: PropTypes.func.isRequired,		// 选中一个条目的回调
	removeItems: PropTypes.func.isRequired,		// 祛选中一个条目的回调
	isLazyLoadData: PropTypes.bool, // 是否使用对数据进行懒加载的功能
	lazyLoadOrganization: PropTypes.func, // 使用懒加载数据的时候，需要在获取子部门时调用的方法
};
export default SelectManager;
